import Vue from 'vue';
import _ from 'lodash';
import sanitizeHtml from 'sanitize-html';

const types = {
  LOADING: 'LOADING',
  GET_OVERVIEW_SUCCESS: 'GET_OVERVIEW_SUCCESS',
  GET_OVERVIEW_FAIL: 'GET_OVERVIEW_FAIL',
  GET_ANNOUCEMENTS_SUCCESS: 'GET_ANNOUCEMENTS_SUCCESS',
  GET_NEWS_SUCCESS: 'GET_NEWS_SUCCESS'
};

// initial state
const initalState = {
  loading: false,
  annoucements: [],
  news: [],
  statsTotal: [],
};

// getters
const getters = {
  loading: state => state.loading,
  chartOptions: () => chartOptions,
  annoucements: state => state.annoucements.map(item => ({
    title: _.get(item, 'title.rendered'),
    description: sanitizeHtml(_.get(item, 'excerpt.rendered'), {
      allowedTags: [],
      allowedAttributes: {}
    }),
    date: _.get(item, 'date'),
    link: _.get(item, 'link'),
  })),
  news: state => state.news.map(item => ({
    title: _.get(item, 'title.rendered'),
    description: sanitizeHtml(_.get(item, 'excerpt.rendered'), {
      allowedTags: [],
      allowedAttributes: {}
    }),
    date: _.get(item, 'date'),
    link: _.get(item, 'link'),
  })),
  statsTotal: state => state.statsTotal,
};

const chartOptions = {
  scales: {
    yAxes: [{
      ticks: {
        beginAtZero: true
      },
      gridLines: {
        display: true
      }
    }],
    xAxes: [ {
      gridLines: {
        display: false
      }
    }]
  },
  responsive: true,
  maintainAspectRatio: false,
};

// actions
const actions = {
};

// mutations
const mutations = {
  [types.LOADING](state, loading) {
    state.loading = loading;
  },

  [types.GET_OVERVIEW_SUCCESS](state, stats) {
    state.loading = false;
    Vue.set(state, "statsTotal", stats);
  },

  [types.GET_OVERVIEW_FAIL](state) {
    state.loading = false;
  },

  [types.GET_ANNOUCEMENTS_SUCCESS](state, data) {
    Vue.set(state, "annoucements", data);
  },

  [types.GET_NEWS_SUCCESS](state, data) {
    Vue.set(state, "news", data);
  }
};

export default {
  namespaced: true,
  state: initalState,
  getters,
  actions,
  mutations,
};
